export default {
    sidePill: {
        buy: 'Nakup',
        sell: 'Prodaja',
    },
}
